export const otrom =     {
    action: 'read',
    subject: 'ACL'
}

export const otro = {
                     action: 'read',
                     subject: 'Auth'
                }
export const all = {
    action: 'manage',
    subject: 'all'
}